import React from "react";
import { Box } from "@mui/material";
import GeneralClientReport from "../../Reports/ReportItems/GeneralClientReport";
import useReportFilter from "../useReportFilter";

/**
 * The client report follows the hub's shared, URL-backed filters: the range
 * and the (admin-only) consultant selection are handed down as
 * `controlledRange`, which hides the report's own date toolbar (the filter bar
 * above already shows the active range).
 */
const ClientsTab: React.FC = () => {
  const { start, end, consultant } = useReportFilter();

  return (
    <Box>
      <GeneralClientReport controlledRange={{ start, end, consultant }} />
    </Box>
  );
};

export default ClientsTab;
